import type { Directive } from 'vue';

import { createDirectiveRegistry, preventPaste } from '@emobg/web-utils';

const registry = createDirectiveRegistry();

export const NoClipboard: Directive = {
  mounted(element) {
    registry.save(element, preventPaste(element));
  },
  unmounted(element) {
    registry.clean(element);
  },
} as const;
